import { Controller } from '@hotwired/stimulus'

export default class RoundingSaveController extends Controller {
  save(): void {
    window.eventHub.$emit('rounding-configuration:save')
  }
}
